export interface ILogin {
  typeMail?: string;
  username?: string;
  password?: string;
  activationCode?: string;
  confirmationCode?: string;
  mfa?: number;
}

export class Login implements ILogin {
  constructor(
    public typeMail?: string,
    public username?: string,
    public password?: string,
    public activationCode?: string,
    public confirmationCode?: string,
    public mfa?: number
  ) {
  }
}
